import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const USER_API = environment.apiUrl;
const TURNAMENT_API = environment.apiUrl + 'tournament';
const ADMIN_DASHBOARD_API = environment.apiUrl + 'admindashboard/';


@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    constructor(private http: HttpClient) {}

    getTournamentsOverview(): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'tournaments-overview?status=merged');
    }


    getMetricsSummary(): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'metrics');
    }

    getStatistics(period): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'statistics?range=' + period);
    }

    getpendingApprovals(): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'pending-approvals');
    }

    getEarningBreakdownData(period): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'earnings-breakdown?range=' + period);
    }

    getAcademyDistributionData(period): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'academy-distribution?range=' + period);
    }

    getNewRegistrationTrendData(period): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'registration-trend?range=' + period);
    }

    getAppDownloadsData(period): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'app-downloads?range=' + period);
    }

    getSubscribedUsersData(): Observable<any> {
        return this.http.get(ADMIN_DASHBOARD_API+'subscribed-users-breakdown');
    }

    getAllAcademyListCount(query): Observable<any> {
        return this.http.get(USER_API + 'tournament/v1?' + query);
    }

    getAllAcademyList(query): Observable<any> {
        return this.http.get(USER_API + "/tournament/v1?" + query);
    }

    getAllWalletRedemptionListCount(query): Observable<any> {
        return this.http.get(USER_API + 'user-redemption?' + query);
    }

    getAllAcademyRedemptionListCount(query): Observable<any> {
        return this.http.get(USER_API + 'user-redemption/academy-list?' + query);
    }
    getAllProPlayerInactiveListCount(query): Observable<any> {
        return this.http.get(USER_API + 'user?' + query);
    }

    getTournamentDeleteRequestCount(query): Observable<any> {
        return this.http.get(TURNAMENT_API + "?" + query);
    }
}